/*
 * @Date: 2023-11-23 19:06:14
 * @LastEditors: fangdong dong.fang@quvideo.com
 * @LastEditTime: 2024-03-14 13:40:46
 * @Email: feng.chen@quvideo.com
 * @Copyright(c): QuVideo F2E Team
 */
'use client';

// txcos：腾讯对象存储 alioss：阿里云对象存储
const ossType = 'txcos';
// export const ossType = 'alioss';
const APP_ENV = process.env.APP_ENV;
const isQa = APP_ENV === 'us_qa';
const isDev = APP_ENV === 'development';

const domain = isQa ? 'https://falcocut-qa.fireflyfusion.cn' : 'https://falcocut.ai';

const subPath = isQa ? 'daily/_next/static' : 'prod/_next/static';

export default function myImageLoader({ src, width, quality }) {
  const env = process.env.NEXT_PUBLIC_ENV;
  const isDev = env === 'development';
  if (ossType === 'alioss') {
    if (src.startsWith('http')) {
      if (src.endsWith('png') || src.endsWith('jpg') || src.endsWith('jpeg')) {
        return src + '?x-oss-process=image/format,webp';
      }
      return src;
    }
    if (isDev) return src;
    let dealString = 'x-oss-process=image';
    if (width) dealString += `/resize,m_lfit,w_${width}`;
    if (quality) dealString += `/quality,q_${quality}`;
    dealString += '/format,webp';
    let path = src;
    if (src.startsWith('/')) {
      path = src.substring(1);
    }

    return `${domain}/web/video-marketing/${subPath}/${path}?${dealString}`;
  } else {
    if (src.startsWith('http')) {
      if (src.endsWith('png') || src.endsWith('jpg') || src.endsWith('jpeg')) {
        return src + '?imageMogr2/format/webp';
      }
      return src;
    }
    if (isDev) return src;
    let dealString = 'imageMogr2';
    if (width) dealString += `/thumbnail/${width}x`;
    if (quality) dealString += `/quality/${quality}`;
    dealString += '/format/webp';
    let path = src;
    if (src.startsWith('/')) {
      path = src.substring(1);
    }
    // return `${domain}/web/video-marketing/${subPath}/${path}?${dealString}`;
    return `${domain}/${path}?${dealString}`;
  }
}
